import { useState } from "react"
import ReactDOM from "react-dom";
import { useSelector } from "react-redux"

import ViewDocument from "./controls/ViewDocument"
import DownloadDocument from "./controls/DownloadDocument"
import LockUnlockDocument from "./controls/LockUnlockDocument"
import ShareLinkDocument from "./controls/ShareLinkDocument"
import Button from "../../../../common/Button"
import Backdrop from "../../../../common/modal/Backdrop";
import Modal from "../../../../common/Modal";
import ModalInnerWrapper from "../../../../common/ModalInnerWrapper";
import DownloadConfirmation from "./DownloadConfirmation";
import { documentHasFileId } from "../../../../../lib/docs";

import classes from './DocumentsTabListItemControls.module.css'

export default function DocumentsTabListItemControls({item, isPrevious, parent}) {
    
    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 

    const [openDownloadConfirmation, setOpenDownloadConfirmation] = useState(false)
    const [openViewConfirmation, setOpenViewConfirmation] = useState(false)

    const downloadFileHandler = () => {
        setOpenDownloadConfirmation(prevState => prevState = !prevState)
    }

    const viewFileHandler = () => {
        setOpenViewConfirmation(prevState => prevState = !prevState)
    } 

    return <div className={classes.container}>
        {!isPrevious && <>
            <LockUnlockDocument userToken={userToken} activeCase={activeCase} item={item}/>
            <ShareLinkDocument userToken={userToken} activeCase={activeCase} item={item} docType={'procodocs'}/>
            <ViewDocument userToken={userToken} activeCase={activeCase} item={item} btnStyle='btn_simple' docType={'procodocs'}>
                <i className="ti ti-eye"></i>
            </ViewDocument>
            <DownloadDocument userToken={userToken} activeCase={activeCase} item={item} btnStyle='btn_simple' docType={'procodocs'}>
                <i className="ti ti-download"></i>
            </DownloadDocument>   
        </>}     

        {isPrevious && documentHasFileId(item) && <>
            <Button btnStyle={'btn_simple'} click={viewFileHandler}>
                <i className="ti ti-eye"></i>
                <span className="sr-only">view {item.name}</span>
            </Button>
            <Button btnStyle={'btn_simple'} click={downloadFileHandler}>
                <i className="ti ti-download"></i>
                <span className="sr-only">download {item.name}</span>
            </Button>
        </>}

        {openDownloadConfirmation && <>
            {ReactDOM.createPortal(
                <Backdrop hide={downloadFileHandler} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={downloadFileHandler} modalTitle={'Download File?'}>
                        <DownloadConfirmation closeModal={downloadFileHandler} parent={parent} file={item} userToken={userToken} activeCase={activeCase} docType={'procodocs'}/>
                    </ModalInnerWrapper>
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}

        {openViewConfirmation && <>
            {ReactDOM.createPortal(
                <Backdrop hide={viewFileHandler} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={viewFileHandler} modalTitle={'View File?'}>
                        <DownloadConfirmation closeModal={viewFileHandler} parent={parent} file={item} isView={true} userToken={userToken} activeCase={activeCase} docType={'procodocs'}/>
                    </ModalInnerWrapper>
                    
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>} 
    </div>
}